import React,{useState, useEffect} from 'react';
import * as dbServices from "../../utils/dbServices";
import MnNavBar from './mnNavbar';


function MnEditorMain(props) {

    const years = ["2026","2025", "2024", "2023", "2022", "2021", "2020", "pre-2020"]

    const data = [ 
        {
        "year": 2026,
        "meetingId": 2,
        "meetingName": "Feb 2026",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2026/CSCAMinutes202602.pdf"
        },
        {
        "year": 2026,
        "meetingId": 3,
        "meetingName": "Mar 2026",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2026/CSCAMinutes202603.pdf"
        },        
        {
        "year": 2026,
        "meetingId": 4,
        "meetingName": "Apr 2026",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2026/CSCAMinutes202604.pdf"
        },
        {
        "year": 2025,
        "meetingId": 1,
        "meetingName": "Jan 2025",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202501.pdf"
        },
        {
        "year": 2025,
        "meetingId": 2,
        "meetingName": "Feb 2025",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202502.pdf"
        },
        {
        "year": 2025,
        "meetingId": 3,
        "meetingName": "Mar 2025",
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202503.pdf"
        },
        {
        "year": 2025,
        "meetingId": 8,
        "meetingName": "Aug 2025",        
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202508.pdf"
        },
        {
        "year": 2025,
        "meetingId": 9,
        "meetingName": "Sep 2025",        
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202509.pdf"
        },
        {
        "year": 2025,
        "meetingId": 10,
        "meetingName": "Oct 2025",        
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202510.pdf"
        },
        {
        "year": 2025,
        "meetingId": 11,
        "meetingName": "Nov 2025",        
        "url": "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2025/CSCAMinutes202511.pdf"
        },
        {
        "year": 2024,
        "meetingId": 1,
        "meetingName": "Jan 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/14008c5c67dd04e959e545ef5d97d1ebc8840156b7de9376472ec6924cb7a905/CSCA-Jan-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 2,
        "meetingName": "Feb 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/6816aae09c98cb57de455debfdff18eaa9aefda0afa47727bfd0254c2f8c787c/CSCA-Feb-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 3,
        "meetingName": "Mar 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/5205202bbf4792e7e9afe37ae949dcf2bdd45e84c028bd74cbfca68c3ec68edf/CSCA-Mar-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 4,
        "meetingName": "Apr 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/969f54a5c6c7440c8aa5423c4e0e3a62f7eb3fe9abd9da5a2a6d00b71848c0b5/CSCA-April-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 5,
        "meetingName": "Ann 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/e63017e2ce19865fa3bc335aba4186f00f72d74e2227592e028ccafda30d1669/CSCA-Annual-April-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 6,
        "meetingName": "May 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/8e92f952ac9f1d4c1a1dac1b7341270b4f8be995d696e6f0e4f0c0261a98b931/CSCA-Special-May-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 7,
        "meetingName": "Jun 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/a64b274e01e2b944d3c1e849cf8553a3dd2ad8b42216df91d49c53608ebcf8d0/CSCA-June-2024.pdf"
        },
        {
        "year": 2024,
        "meetingId": 8,
        "meetingName": "Aug 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/4f964762dbfcb5b4eb06c857d0172121e4484e49bd47f8cbbc5a0456f2eb90cd/Minutes-2024-0819-CSCA.pdf"
        },
        {
        "year": 2024,
        "meetingId": 9,
        "meetingName": "Sep 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/a539aaacd6d632c780fe098d7fd8a8f9ba284336c4c47e73c97759cc2624c292/Mnitues-2024-0917-CSCA.pdf"
        },
        {
        "year": 2024,
        "meetingId": 10,
        "meetingName": "Oct 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/72cacb30fd90b545b0adf2baec644b8bb058719e861fe8549855280db731254c/Minutes-2024-1021-CSCA.pdf"
        },
        {
        "year": 2024,
        "meetingId": 11,
        "meetingName": "Nov 2024",
        "url": "https://cloud-1de12d.becdn.net/customfile/c5ecdbc6bdd0506abe44c2ed82b55d35456399e75a42e7e28534a6195f87a976/Minutes-2024-1118-CSCA.pdf"
        },
        {
        "year": 2023,
        "meetingId": 1,
        "meetingName": "Jan 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/62219fdcea0a0daabac2c69b09f94cc5ca12f0aa1976f80111e339ab8ec8d3f7/CSCA-Jan-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 2,
        "meetingName": "Feb 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/aec3b8d427bb2f086538563a7d52edecf17dc12963f532b18ac5eddee3b3d158/CSCA-Feb-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 3,
        "meetingName": "Mar 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/d35c5694dbee25841738d8184c0ac18151289f396ad2a0745eef31c3a0465835/CSCA-Mar-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 4,
        "meetingName": "Apr 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/6b227559e7557bfca0ad2ccec94274d862e79e91898f586ccef3fc00d55df1c7/CSCA-Apr-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 5,
        "meetingName": "Ann 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/01b5c8d8d5342cbeff55ff04fc29bca2867092838059009c3aed04a6849f45ca/CSCA-Annual-May-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 6,
        "meetingName": "May 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/fd74f841ddb0bb6f1e0659de30683ef8cb09fdf1adbec2eb8a4a67f6251a79a5/CSCA-May-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 7,
        "meetingName": "Aug 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/d646f3c8e8d9039cf96cfb44259df53f6e804237ab6b418ae6d72b53386d91a1/CSCA-Aug-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 8,
        "meetingName": "Sep 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/31a3652f871c8301e630b2a04cb474362083f6abcae78921461d06a7bdfca3e4/CSCA-Sep-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 9,
        "meetingName": "Oct 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/890fe6e4300ed40a8d4bec9c11daa0ee1b9294d0d560aa7b4555cf97aeb97482/CSCA-Oct-2023.pdf"
        },
        {
        "year": 2023,
        "meetingId": 10,
        "meetingName": "Nov 2023",
        "url": "https://cloud-1de12d.becdn.net/customfile/c3380803a0e22110a8fc14dc0e795f5c6e5d5535912d144cb2c64e646f55da42/CSCA-Nov-2023.pdf"
        }
    ]
    
    const [selectedYear, setSelectedYear] = useState("2026")
    const [leftItem, setLeftItem] =  useState("2025")
    const [reportData, setReportData] = useState({year: 2026,meetingId: 4,meetingName: "Apr 2026",url: "https://statikostrio.baradinrtllc.com/csca/meetingMinutes/2026/CSCAMinutes202604.pdf"})
    const [isHover, setIsHover] = useState({x:"",h:false});
    // const [data,setData] = useState([])

    useEffect(() => {
        getData();
    },[])

    const getData = async () =>{
        // const temp = await dbServices.getCategories()
        // console.log(temp)
        // setData([...temp])
    }

    const handleMouseEnter = (x) => {
        setIsHover({x,h:true});
    };

    const handleMouseLeave = (x) => {
        setIsHover({x,h:false});
    };

    const handleLeftItem = (e,x) =>{
        setLeftItem(x)
    }

    const handleReportClick = (e,x) =>{
        console.log(x)
        setReportData(x)
    }

    const getStyleLeftItems = (x) =>{

        let styleObj = {
            backgroundColor: (isHover["x"]===x && isHover["h"]) ? '#424242' : 'rgb(52, 58, 64)',
            color: (isHover["x"]===x && isHover["h"])  ? 'white' : '#BDBDBD',
        }

        if (x===leftItem) return ({cursor:"pointer", background:"424242", color:"white", fontSize:"22px",fontFamily:"Palanquin Dark, sans serif", ...styleObj})

        return ({cursor:"pointer",background:"424242", color:"#BDBDBD", fontFamily:"Palanquin Dark, sans serif",...styleObj})    
    }

    const getStyleLeftItems2 = (x) =>{

        let styleObj = {
            backgroundColor: (isHover["x"]===x && isHover["h"]) ? '#424242' : 'rgb(52, 58, 64)',
            color: (isHover["x"]===x && isHover["h"])  ? 'white' : '#BDBDBD',
        }

        if (x===leftItem) return ({cursor:"pointer", color:"white", fontSize:"18px", fontFamily:"Palanquin Dark, sans serif"})

        return ({cursor:"pointer",background:"424242", color:"#BDBDBD", fontFamily:"Palanquin Dark, sans serif"})    
    }    

    const getYearRow =  (x) =>{

        if(x===leftItem){
            const temp = data.filter(y=>y["year"]==leftItem)
            console.log(temp)
            return(
                <>
                    <div className="row mb-4">
                        <div className="col-12">
                            <span className="ml-4 pl-1" onMouseEnter={()=>handleMouseEnter(x)}  onMouseLeave={()=>handleMouseLeave(x)} style={getStyleLeftItems(x)} onClick={e=>handleLeftItem(e,x)}>{x}</span>
                        </div>
                    </div>
                
                    {temp.map((y,idx)=>(
                        <div className="row mb-4">
                            <div className="col-12">
                                <span className="ml-4 pl-3" style={getStyleLeftItems2(x)} onClick={e=>handleReportClick(e,y)}>{y["meetingName"]}</span>
                            </div>
                        </div> 
                    ))}
                </>
            )

        }

        return(
            <div className="row mb-4">
                <div className="col-12">
                    <span className="ml-4 pl-2" onMouseEnter={()=>handleMouseEnter(x)}  onMouseLeave={()=>handleMouseLeave(x)} style={getStyleLeftItems(x)} onClick={e=>handleLeftItem(e,x)}>{x}</span>
                </div>
            </div>
        )
    }

    const leftCol = (years) =>{

        return(
            <>
                <div className="row my-4">
                    <h5 className="ml-4 pl-1" style={{fontFamily:"Palanquin Dark, sans serif", color:"white", fontSize:"26px"}}>Years</h5>
                </div>
                {years.map((x,idx)=>
                    getYearRow(x)
                )}
            </>
        )
    }

    const pdfSection = () =>{

        return(
            <>
                <div className="row mb-4 mt-2">
                    <div className = "col-1">

                    </div>
                    <div className = "col-10">
                        <h5>Meeting Notes For {reportData["meetingName"]}</h5>
                    </div>
                </div>
                <div className="row mb-4 mt-4" >
                    <div className="col-1">

                    </div>
                    <div style={{border:"1px black solid"}} className="col-10 d-flex justify-content-center align-items-center">
                        <iframe
                            src={reportData["url"]}
                            width="100%"
                            height="800px"
                            title="PDF Viewer"
                            style={{ border:"none"}}
                        />
                   </div>
                </div>                
            </>
        )
    }

    // if(data.length===0) return null

    return(
        <>
            <br/>
            <MnNavBar data={data} years={years} onReportClick={handleReportClick} />
            <br/>
            {pdfSection()}

        </>
    )

}

export default MnEditorMain;